<template>
    <div style="display:flex;flex-direction:column;min-height:100%;">

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <!-- Sticky title bar -->
        <div class="fs-title-bar">
            <h2 class="pb-2">{{ this.parentObject.pageTitle }}</h2>
        </div>

        <v-container style="max-width:100%;overflow-x:hidden;flex:1;">
            <v-form ref="form">
                
                <v-container
                    id="scroll-target"
                    class="custom-form px-5"
                    style="max-width:100%;"
                >

                    <div>
                        <v-row>
                            <v-col cols="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.description')"
                                    ref="description"
                                    readonly
                                    v-model="readOnly.description"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    ref="goal"
                                    readonly
                                    v-model="readOnly.goal"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" class="mt-n6 mb-2">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    ref="kpi"
                                    readonly
                                    v-model="readOnly.kpi"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6" class="pb-n4 mt-n8 ml-3">
                                <v-row>
                                    <v-col cols="4" sm="4" class="pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('columns.target')"
                                            type="text"
                                            v-model="readOnly.target"
                                            dense
                                            class="v-input"
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                    <!-- <v-col cols="4" sm="4" class="px-0">    
                                        <v-text-field
                                            outlined
                                            :label="$t('Setupformreviewsection.weightage')"
                                            type="text"
                                            v-model="readOnly.weightage"
                                            dense
                                            class="v-input"
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col> -->
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>

                    <v-row>
                        <v-col cols="12">
                            <app-table-affected-groups
                                v-bind:parentObject = "{
                                    tabHeader: this.affectedGroupsTabHeader,
                                    formData: this.formData,
                                    calcMethod: this.readOnly.pmcalmethodid,
                                    target: this.readOnly.target,
                                }"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <app-table
                                v-bind:parentObject = "{
                                    tabHeader: this.tabHeader,
                                    formData: this.formData,
                                    calcMethod: this.readOnly.pmcalmethodid,
                                    target: this.readOnly.target,
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-container>

                
            </v-form>
        </v-container>

        <!-- Full-width Back button bar -->
        <div class="kpi-btn-bar">
            <div class="kpi-btn-inner">
                <v-btn class="fbtn fbtn-back" @click="backHandler">
                    <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                    {{ $t('button.back') }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import CRUDTable from './CRUDTableCommonKPI';
import CRUDTableAffectedGroups from './CRUDTableCommonKPIAffectedGroups';

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
       'app-table-affected-groups': CRUDTableAffectedGroups,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            readOnly: this.parentObject.data.commonDetails,

            formData: {
                commonkpiid: this.$route.params.id,
                reviewdate: null,
                achievement: null,
                comments: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                progress: null,
                target: null,
                calcMethod : null
            },

            errMsg: "",
            isErr: false,

            progressCommonKpiListdetail: [],
            loadingCommonKpiProgress: false,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('pmreviewexercisesectioncard.reviewdate'), value: 'reviewdate', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.achievement'), value: 'achievement', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.progress'), value: 'progress', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.comments'), value: 'comments', width: '200px', sortable: true},
            ],

            affectedGroupsTabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.company'), value: 'companycode', width: '200px', sortable: true},
                { text: this.$t('columns.branch'), value: 'branchcode', width: '200px', sortable: true},
                { text: this.$t('columns.division'), value: 'divisioncode', width: '200px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '200px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectioncode', width: '200px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unit', width: '200px', sortable: true},
                { text: this.$t('columns.employmenttype'), value: 'emptype', width: '200px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grade', width: '200px', sortable: true},
                { text: this.$t('columns.job'), value: 'job', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.weightage'), value: 'weightage', width: '200px', sortable: true},
            ],

            //load kpi common list handler
            async loadKpiCommonListHandler() {
                const vm = this;
                vm.loadingCommonKpiProgress = true;

                await this.$store.dispatch('get', {url: "/kpicommonprogress/" + vm.$route.params.id})
                .then((res) => {

                    for(let i = 0; i < res.data.rec.length; i++) {
                        
                        if(res.data.rec[i].reviewdate){
                            res.data.rec[i].reviewdate = moment(res.data.rec[i].reviewdate).format('YYYY-MM-DD');
                        }
                    }
                    
                    vm.progressCommonKpiListdetail = res.data.rec;
                    vm.loadingCommonKpiProgress = false;
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
            },
        }
    },

    methods: {
        backHandler(){
            this.$router.push({name: 'kpisettingedit', params: { id: this.parentObject.data.kpiexerid } });
        },
    }, 

    created() {
        this.loadKpiCommonListHandler();
    },
}
</script>

<style scoped>
.fs-title-bar {
    position: sticky;
    top: 0;
    z-index: 20;
    background: #ffffff;
    padding: 16px 24px 0 24px;
}
.kpi-btn-bar {
    background: #F8FAFF;
    border-top: 1px solid #E8EDF5;
    border-radius: 0 0 16px 16px;
    padding: 16px 20px;
    margin-top: 8px;
    width: 100%;
}
.kpi-btn-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.fbtn {
    min-width: 100px !important;
    height: 38px !important;
    border-radius: 8px !important;
    font-size: 0.82rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0.02em !important;
    box-shadow: none !important;
    transition: all 0.15s !important;
}
.fbtn-back { background: #F97316 !important; color: #fff !important; }
.fbtn-back:hover { background: #EA6C0A !important; }
</style>